export const isAllowedOnboardingVideoSrc = (src: string, allowedHost: string) => {
  if (!src || !allowedHost) {
    return false;
  }

  try {
    const srcUrl = new URL(src);
    const hostUrl = new URL(allowedHost.endsWith('/') ? allowedHost : `${allowedHost}/`);
    return srcUrl.origin === hostUrl.origin && srcUrl.protocol === hostUrl.protocol;
  } catch {
    return false;
  }
};
